import api from '@/api';
import { API_BASE_URL } from '..';
import {
  GetNumberings,
  NumberingsRequest,
  NumberingsResponse,
} from './Numberings.types';

const CONTROLLER_URL = `${API_BASE_URL}/invoice-settings/invoice-numberings`;

export async function listNumberingsInvoice(obj: GetNumberings) {
  const result = (await api.get(CONTROLLER_URL, obj)) as unknown;

  return result as NumberingsResponse[];
}

export async function createNumberingsInvoice(obj: NumberingsRequest) {
  const result = (await api.post(CONTROLLER_URL, obj, null)) as unknown;

  return result as NumberingsResponse;
}

export async function deleteNumberingsInvoice(id: number) {
  const result = await api.remove(`${CONTROLLER_URL}/${id}`, {}, null);

  return result;
}

export async function updateNumberingsInvoice(obj: NumberingsRequest) {
  const { id, ...values } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${id}`,
    values,
    null,
  )) as unknown;
  return result as NumberingsResponse;
}

export async function getNumberingInvoiceId(id: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;
  return result as NumberingsResponse;
}
